import {
  TopToolbar,
  ListButton,
  EditButton,
  DeleteWithConfirmButton,
  useResourceDefinition,
} from 'react-admin';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Card, Grid } from '@mui/material';
import PageTitleWrapper from './PageTitleWrapper';
import PageHeader from './PageHeader'
import AnimatedBlock from '../Common/AnimatedBlock';
import { IfCanAccess } from '@react-admin/ra-rbac';
import { resourceNoun } from './resourceNouns';



// Detail page actions: back to the list, then edit and delete when the resource has
// them. Creating a new record belongs to the list page, not to a record's page.
export const ShowActions = ({ resource }) => {
  const { hasEdit } = useResourceDefinition({ resource });
  return (
    <TopToolbar>
      <IfCanAccess action="list" resource={resource}>
        <ListButton label="Back to list" icon={<ArrowBackRoundedIcon />} />
      </IfCanAccess>
      {hasEdit && resource !== "cryptoOrders" && (
        <IfCanAccess action="edit" resource={resource}>
          <EditButton icon={<EditOutlinedIcon />} />
        </IfCanAccess>
      )}
      <IfCanAccess action="delete" resource={resource}>
        <DeleteWithConfirmButton
          icon={<DeleteOutlineIcon />}
          confirmTitle={`Delete this ${resourceNoun(resource)}?`}
          confirmContent="This cannot be undone."
          confirmColor="warning"
        />
      </IfCanAccess>
    </TopToolbar>
  );
};

const ComponentShow = ({ children, title = "", subtitle = "", header = null }: { children: any; title?: string; subtitle?: string; header?: any }) => (
  <>
    <PageTitleWrapper>
      {header || <PageHeader title={title} subtitle={subtitle} />}
    </PageTitleWrapper>
    <Grid
      sx={{
        px: { xs: 2, sm: 4 },
      }}
      container
      direction="row"
      justifyContent="center"
      alignItems="stretch"
      spacing={4}
    >
      <Grid item xs={12} >
        <AnimatedBlock>
          <Card>
            {children}
          </Card>
        </AnimatedBlock>
      </Grid>
    </Grid>
  </>
);



export default ComponentShow;